import {
  bootstrapApplication,
} from '@angular/platform-browser';

import { environment } from './environments/environment';
import '@angular/compiler';
import { AppComponent } from 'app/app.component';

import { appConfig } from './app/app.config';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));